import { useState } from 'react';

const NAV_LINKS = [
  { href: '#today', label: '今日汇总' },
  { href: '#hot', label: '热门合集' },
  { href: '#packs', label: '精选打包' },
  { href: '#comments', label: '热评现场' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/80 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 md:px-6">
        {/* 品牌 */}
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-base font-black text-background-50">
            51
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            吃料
          </span>
          <span className="ml-1 hidden rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-800 sm:inline-block">
            每日汇总站
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* 右侧动作 */}
        <div className="flex items-center gap-2">
          <a
            href="#packs"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            一键开吃
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#packs"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              一键开吃
            </a>
          </div>
        </div>
      )}
    </header>
  );
}